// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactSaveDto
 */
export interface IContactSaveDto {
    /**
     * 
     * @type {number}
     * @memberof IContactSaveDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IContactSaveDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     * @deprecated
     */
    role?: IContactSaveDtoRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof IContactSaveDto
     */
    role_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    department?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContactSaveDto
     */
    primary: boolean;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    contact_type: IContactSaveDtoContactTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    contact_status_type: IContactSaveDtoContactStatusTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContactSaveDto
     */
    email_communication_type_list?: Array<IContactSaveDtoEmailCommunicationTypeListEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IContactSaveDto
     */
    claims_teams_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof IContactSaveDto
     */
    domain_type?: IContactSaveDtoDomainTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof IContactSaveDto
     */
    job_function_types?: Set<IContactSaveDtoJobFunctionTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoRoleEnum {
    SUPER_USER = 'SUPER_USER',
    ADMIN_1 = 'ADMIN_1',
    ADMIN_2 = 'ADMIN_2',
    ADMIN_3 = 'ADMIN_3',
    CLAIMS_PROCESSOR_REVIEW = 'CLAIMS_PROCESSOR_REVIEW',
    CLAIMS_PROCESSOR_EDIT = 'CLAIMS_PROCESSOR_EDIT',
    AGENT = 'AGENT',
    NO_ACCESS = 'NO_ACCESS',
    CLAIMS_SUPERVISOR = 'CLAIMS_SUPERVISOR'
}
/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoContactTypeEnum {
    EMPLOYER = 'EMPLOYER',
    SYSTEM = 'SYSTEM'
}
/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoContactStatusTypeEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    PENDING = 'PENDING',
    EXPRESS_VERIFICATION = 'EXPRESS_VERIFICATION',
    EXPRESS_ORGANIZATION = 'EXPRESS_ORGANIZATION'
}
/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoEmailCommunicationTypeListEnum {
    FINANCE = 'FINANCE',
    FILES = 'FILES',
    PLAN_MANAGEMENT = 'PLAN_MANAGEMENT',
    REPORTS = 'REPORTS'
}
/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoDomainTypeEnum {
    ENROLLMENT = 'ENROLLMENT',
    EMPLOYEE = 'EMPLOYEE',
    CLAIM = 'CLAIM',
    ORGANIZATION = 'ORGANIZATION',
    PLAN = 'PLAN',
    PLAN_YEAR = 'PLAN_YEAR',
    PLAN_CONFIGS = 'PLAN_CONFIGS',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    LOCKBOX = 'LOCKBOX',
    DEDUCTIBLES = 'DEDUCTIBLES',
    ACCOUNT = 'ACCOUNT',
    HEALTH_PLAN = 'HEALTH_PLAN',
    PLAN_TERM_PROPERTIES = 'PLAN_TERM_PROPERTIES',
    CHECK = 'CHECK',
    ROLE = 'ROLE',
    CARD = 'CARD',
    LETTER_OF_MEDICAL_NECESSITY = 'LETTER_OF_MEDICAL_NECESSITY',
    SERVICE = 'SERVICE',
    COPAY = 'COPAY',
    PAYMENT_METHOD = 'PAYMENT_METHOD',
    INVESTMENTS = 'INVESTMENTS',
    CIP = 'CIP',
    PAYOUT_DEFINITION = 'PAYOUT_DEFINITION',
    CARD_PURSE = 'CARD_PURSE',
    CONTRIBUTION = 'CONTRIBUTION'
}
/**
* @export
* @enum {string}
*/
export enum IContactSaveDtoJobFunctionTypesEnum {
    ACCOUNT_MANAGER = 'ACCOUNT_MANAGER'
}


/**
 * Check if a given object implements the IContactSaveDto interface.
 */
export function instanceOfIContactSaveDto(value: object): value is IContactSaveDto {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('primary' in value) || value['primary'] === undefined) return false;
    if (!('contact_type' in value) || value['contact_type'] === undefined) return false;
    if (!('contact_status_type' in value) || value['contact_status_type'] === undefined) return false;
    return true;
}

export function IContactSaveDtoFromJSON(json: any): IContactSaveDto {
    return IContactSaveDtoFromJSONTyped(json, false);
}

export function IContactSaveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactSaveDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'username': json['username'] == null ? undefined : json['username'],
        'role': json['role'] == null ? undefined : json['role'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'department': json['department'] == null ? undefined : json['department'],
        'primary': json['primary'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'contact_type': json['contact_type'],
        'contact_status_type': json['contact_status_type'],
        'email_communication_type_list': json['email_communication_type_list'] == null ? undefined : json['email_communication_type_list'],
        'claims_teams_ids': json['claims_teams_ids'] == null ? undefined : json['claims_teams_ids'],
        'domain_type': json['domain_type'] == null ? undefined : json['domain_type'],
        'job_function_types': json['job_function_types'] == null ? undefined : new Set(json['job_function_types']),
    };
}

export function IContactSaveDtoToJSON(json: any): IContactSaveDto {
    return IContactSaveDtoToJSONTyped(json, false);
}

export function IContactSaveDtoToJSONTyped(value?: IContactSaveDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'username': value['username'],
        'role': value['role'],
        'role_id': value['role_id'],
        'title': value['title'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'phone': value['phone'],
        'department': value['department'],
        'primary': value['primary'],
        'external_identifier': value['external_identifier'],
        'contact_type': value['contact_type'],
        'contact_status_type': value['contact_status_type'],
        'email_communication_type_list': value['email_communication_type_list'],
        'claims_teams_ids': value['claims_teams_ids'],
        'domain_type': value['domain_type'],
        'job_function_types': value['job_function_types'] == null ? undefined : Array.from(value['job_function_types'] as Set<any>),
    };
}

